export type MessageToken =
  | { type: 'text'; value: string }
  | { type: 'strong'; value: string }
  | { type: 'link'; href: string; value: string }

const MESSAGE_TOKEN_PATTERN =
  /<strong>(.*?)<\/strong>|<a href="([^"]*)">(.*?)<\/a>/g

export const tokenizeMessageContent = (content: string): MessageToken[] => {
  const tokens: MessageToken[] = []
  const pattern = new RegExp(MESSAGE_TOKEN_PATTERN)

  let lastIndex = 0
  let match: Nullable<RegExpExecArray>

  while ((match = pattern.exec(content)) !== null) {
    if (match.index > lastIndex) {
      tokens.push({
        type: 'text',
        value: content.slice(lastIndex, match.index),
      })
    }

    const [, strongValue, linkHref, linkValue] = match

    if (strongValue === undefined) {
      tokens.push({ type: 'link', href: linkHref, value: linkValue })
    } else {
      tokens.push({ type: 'strong', value: strongValue })
    }

    lastIndex = pattern.lastIndex
  }

  if (lastIndex < content.length) {
    tokens.push({ type: 'text', value: content.slice(lastIndex) })
  }

  return tokens
}
